export const BASE_URL = 'https://api.miss-kal.uk';
//export const BASE_URL = 'http://192.168.1.234:1337';
